import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { selectField, selectSeason, selectSeasonsDates } from '../../../store/slices/fields';
import { changeZoom } from '../../../store/slices/ui';

const useEditOrDuplicateSeason = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return ({ season, fieldId, currentZoom, disabledDates, isEdit }) => {
    dispatch(selectField({ id: fieldId }));
    dispatch(
      selectSeason({
        id: isEdit ? season.id : '',
        boundaryId: season.boundary_id,
        crop: season.crop_id,
        variety: season.variety,
        sowingDate: season.sowing_date,
        harvestDate: season.harvest_date,
      }),
    );
    dispatch(selectSeasonsDates({ dates: disabledDates }));
    dispatch(changeZoom(currentZoom));
    navigate('/season');
  };
};

export default useEditOrDuplicateSeason;